import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import swal from "sweetalert2";
import { OneSignalService } from '@app/onesignal.service';
import { AppStateService } from '@app/shared/services/app-state.service';
import { MixpanelEventLoggingService } from '@app/shared/services/mixpanel-event-logging.service';
import { WebSocketService } from '../main/roles-shared/services/web-socket.service';
import {SsoMsg} from '@app//util/sso-login-key';
import { SsoLoginService } from '@app/shared/services/sso-login.service';
declare const SecureLS;

@Component({
  selector: 'app-sso-get-response',
  templateUrl: './sso-get-response.component.html',
  styleUrls: ['./sso-get-response.component.css']
})
export class SsoGetResponseComponent implements OnInit {
  canSubmit = true;
  accessToken = "";
  userId = "";
  password = "";
  email = "";
  buttonValidate: boolean;
  rememberMeStatus = "";
  ssoDomainMsg: any;
  domain: any;
  domainname: any;
  secureLocalStorage = new SecureLS({ encodingType: "aes" });
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private oneSignalService: OneSignalService,
    private appStateService: AppStateService,
    private mixpanelEventLoggingService: MixpanelEventLoggingService,
    private webSocketService: WebSocketService, private ssoService: SsoLoginService) {
      this.ssoDomainMsg = SsoMsg;
    }

  ngOnInit() {
    if (window.localStorage.getItem("rememberMeStatus") === "true") {
      this.email = this.secureLocalStorage.get(
        "5dr34cxv@9_x!fo2s8%^4uo93#in*"
      ).email;
      this.password = this.secureLocalStorage.get(
        "5dr34cxv@9_x!fo2s8%^4uo93#in*"
      ).password;
      this.rememberMeStatus = "true";
      const x: any = document.getElementById("rem");
      x.checked = true;
    }

    if (
      window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null" &&
      window.localStorage.getItem("rememberMeStatus") === "true" &&
      window.localStorage.getItem("logoutStatus") === "false"
    ) {
      if (
        JSON.parse(window.localStorage.getItem("userDetails")).roles[0].code ===
        "tech_buyer"
      ) {
        this.appStateService.setState(true);
        window.sessionStorage.setItem(
          "userDetails",
          JSON.stringify(JSON.parse(window.localStorage.getItem("userDetails")))
        );
        this.mixpanelEventLoggingService.dispatchEvent("login", {
          "Email ID": "email",
          "User Role": "tech_buyer",
          "Mode of Login": "Email",
          "Device": "Web"
        });
        this.router.navigate(["tech-buyer"]);
      } else if (
        JSON.parse(window.localStorage.getItem("userDetails")).roles[0].code ===
        "tech_vendor"
      ) {
        this.appStateService.setState(true);
        window.sessionStorage.setItem(
          "userDetails",
          JSON.stringify(JSON.parse(window.localStorage.getItem("userDetails")))
        );
        this.mixpanelEventLoggingService.dispatchEvent("login", {
          "Email ID": "email",
          "User Role": "tech_vendor",
          "Mode of Login": "Email",
          "Device": "Web"
        });
        this.router.navigate(["tech-vendor"]);
      } else if (
        JSON.parse(window.localStorage.getItem("userDetails")).roles[0].code ===
        "ecosystm_staff"
      ) {
        this.appStateService.setState(true);
        window.sessionStorage.setItem(
          "userDetails",
          JSON.stringify(JSON.parse(window.localStorage.getItem("userDetails")))
        );
        this.mixpanelEventLoggingService.dispatchEvent("login", {
          "Email ID": "email",
          "User Role": "ecosystm_staff",
          "Mode of Login": "Email",
          "Device": "Web"
        });
        this.router.navigate(["ecosystm-staff"]);
      }
      if (
        JSON.parse(window.localStorage.getItem("userDetails")).roles[0].code ===
        "tech_analyst"
      ) {
        this.appStateService.setState(true);
        window.sessionStorage.setItem(
          "userDetails",
          JSON.stringify(JSON.parse(window.localStorage.getItem("userDetails")))
        );
        this.mixpanelEventLoggingService.dispatchEvent("login", {
          "Email ID": "email",
          "User Role": "tech_analyst",
          "Mode of Login": "Email",
          "Device": "Web"
        });
        this.router.navigate(["tech-analyst"]);
      }
    }
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['param1']) {
        var decodedString = atob(params['param1']);
        let userInfo;
        userInfo = JSON.parse(decodedString);
       // console.log('decodedStringParse==', JSON.parse(decodedString);
    if (userInfo['emailaddress']) {
      this.domain = userInfo['emailaddress'].substring(userInfo['emailaddress'].lastIndexOf("@") + 1);
      this.domainname = this.domain.indexOf(this.ssoDomainMsg.orgDomain);
    }
        /*****Login Functionality start*****/
        this.ssoService.ssoValidateUser(userInfo['emailaddress']).subscribe( (userresponse: any) => {
          if (this.domain && this.domainname < 0 && userresponse) {
            swal("Info", this.ssoDomainMsg.ResponseMsg, "info");
          }
        //  if (window.sessionStorage.getItem("userExist") === 'true') {
            const loginCredentials = {
              email: userInfo['emailaddress'],
              password: "EcoSSO@123"
            };
             this.authenticationService.login(loginCredentials).subscribe(
              (response: any) => {
                this.buttonValidate = false;
               // this.submitCount++;
                this.canSubmit = true;
                this.accessToken = response.id;
                this.userId = response.userId;
                this.getUserDetails();
              },
              error => {
                if (error.status === 403) {
                  swal({
                    title: "Email not verified!",
                    text: "Well, we can resend the link",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#3085d6",
                    confirmButtonText: "Resend",
                    cancelButtonText: "No thanks",
                    confirmButtonClass: "btn adjust-swal-button",
                    cancelButtonClass: "btn adjust-swal-button",
                    buttonsStyling: false
                  }).then(result => {
                    if (result.value) {
                      this.resendVerificationEmail();
                    }
                  });
                } else {
                  swal("Info", error.error.error.message, "info");
                }
              //  this.submitCount++;
                this.canSubmit = true;
              }
            );
             /*****Login Functionality end*****/
            //}
         },
        error => {
         if (this.domain  && error) {
            swal("Info", this.ssoDomainMsg.ErrorMsg, "info");
        }
         // swal("Info", "Please signup with ecosystm", "info");
          this.router.navigate(['/signin'], { replaceUrl: true });
        });
      } else {
        swal("Info", "Please signup with ecosystm", "info");
      }
    });
  }
  resendVerificationEmail() {

    this.authenticationService.resendVerificationEmail(this.email).subscribe(
      response => {

        swal("Success", "Please check your email", "success");
      },
      error => {

        swal("Info", error.error.error.message, "info");
      }
    );
  }
  updateLocalUserProfile() {
    const OneSignal = window['OneSignal'] || [];
    OneSignal.getUserId().then((userId) => {
      // Store OneSignal ID in your server for sending push notificatios.
      const params = {
        // deviceToken = oneSignalId
        deviceToken: userId,
        deviceType: 'browser'
      };
      this.authenticationService.registerWebPushDevice(params).subscribe(
        (response: any) => {
        },
        error => {
        }
      );
    });
  }
  getUserDetails() {
    this.authenticationService
      .getuserDetails(this.userId, this.accessToken)
      .subscribe(
        (response: any) => {
          this.webSocketService.initializeSocket(response.id,response.roles[0].id,this.accessToken)
          response.userId = this.userId;
          response.accessToken = this.accessToken;
          // this.webSocketService.connectSocket();
          // this.webSocketService.initializeSocket(response.id,response.roles[0].id,this.accessToken)
          const userData = {
            salutationId: response.salutationId,
            firstName: response.firstName,
            middleName: response.middleName,
            lastName: response.lastName,
            nickName: response.nickName,
            email: response.email,
            jobTitleId: response.jobTitleId,
            lineOfBusinessId: response.lineOfBusinessId,
            geographicResponsibilityId: response.geographicResponsibilityId,
            organizationId: response.organizationId,
            biography: response.biography,
            isActive: response.isActive,
            profileUrl: response.profileUrl,
            token: this.accessToken
          };
          this.authenticationService.setAuth(userData);
          this.authenticationService.setEBSAuth(response);

          if (this.rememberMeStatus === "true") {
            window.localStorage.setItem("rememberMeStatus", "true");
            this.secureLocalStorage.set("5dr34cxv@9_x!fo2s8%^4uo93#in*", {
              email: this.email,
              password: this.password
            });
            window.localStorage.setItem(
              "userDetails",
              JSON.stringify(response)
            );
          } else {
            window.localStorage.setItem("rememberMeStatus", "false");
            window.localStorage.removeItem("credentials");
            window.localStorage.removeItem("userDetails");
          }
          window.localStorage.setItem("logoutStatus", "false");
          window.sessionStorage.setItem(
            "userDetails",
            JSON.stringify(response)
          );
          //  ------- One Signal Registration - Starts -------
          // Send tags here
          this.oneSignalService.sendPushTags(
            response.userId,
            response.roles[0].code
          );
          // Call subscribe Ecosystm API here
          this.updateLocalUserProfile();
          //  ------- One Signal Registration - Ends -------

          this.mixpanelEventLoggingService.dispatchEvent("login", {
            "Email ID": "email",
            "User Role": response.roles[0].code,
            "Mode of Login": "Email",
            "Device": "Web"
          });
          const redirectURL = localStorage.getItem("REDIRECT_URL");
          localStorage.removeItem("REDIRECT_URL");
          if (redirectURL) {
            this.appStateService.setState(true);
            this.router.navigateByUrl(redirectURL);
          } else {
            if (response.roles[0].code === "tech_buyer") {
              this.router.navigate(["tech-buyer"]);
            } else if (response.roles[0].code === "tech_vendor") {
              this.router.navigate(["tech-vendor"]);
            } else if (response.roles[0].code === "tech_analyst") {
              this.router.navigate(["tech-analyst"]);
            } else if (response.roles[0].code === "ecosystm_staff") {
              this.router.navigate(["ecosystm-staff"]);
            }
          }

          //
        },
        error => {

        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/sso-get-response/sso-get-response.component.ts